<template>
    <div>
        <tab name="8">{{userName}}(ID:{{id}})</tab>
        <user-open :userId="id" :userType="5" :userName.sync="userName"></user-open>
    </div>
</template>

<script>
import Tab from './components/tab';
import UserOpen from '@/views/user/components/user-open';
export default {
    props:{
        id:{
            type:[Number,String],
            default: ''
        }
    },
    components:{
        Tab,UserOpen
    },
    data() {
        return {
            userName:''
        };
    }
}
</script>